<div class="dealer-contact" data-test-id="dealer-contact-container">
  <div class="location-information" data-test-id="dealer-contact-location-info-section">
    <h2 data-test-id="dealer-contact-page-header" class="focus-outline-none location-information__title bold-title" tabindex="-1" #pageHeading>
      {{dealerContactTranslations.pageHeader}}
    </h2>
    @if (showError) {
      <error-message data-test-id="dealer-contact-error-message"></error-message>
    }
    @if (showSuccess) {
      <success-message data-test-id="dealer-contact-success-message" [message]="message"></success-message>
    }
    <div class="location-information__row">
      <div class="location-information__card"
        [ngClass]="{ 'location-information__card-min-height': !isAddressChangeDisabled }"
        [class.editHeight]="phoneEditMode">
        @if (isAddressChangeDisabled) {
          <div class="location-information__card--body">
            <ng-container *ngTemplateOutlet="tmplPhysicalAddressCardBody"></ng-container>
          </div>
        }
        @if (!isAddressChangeDisabled) {
          <div class="location-information__card--body-height">
            <ng-container *ngTemplateOutlet="tmplPhysicalAddressCardBody"></ng-container>
          </div>
        }
      </div>
      <div class="location-information__card middle-card"
        [ngClass]="{ 'location-information__card-min-height': !isAddressChangeDisabled }"
        [class.editHeight]="phoneEditMode" [class.priamryErrorHeight]="
          phoneNumberFormSubmitted && numberFormValidator.primaryNumber.errors && !numberFormValidator.altNumber.errors
        " [class.altErrorHeight]="
          phoneNumberFormSubmitted &&
          numberFormValidator.primaryNumber.errors &&
          !numberFormValidator.primaryNumber.errors
        " [class.errorHeight]="
          phoneNumberFormSubmitted && numberFormValidator.primaryNumber.errors && numberFormValidator.altNumber.errors
        ">
        @if (isAddressChangeDisabled) {
          <div class="location-information__card--body">
            <ng-container *ngTemplateOutlet="tmplTitleAddressCardBody"></ng-container>
          </div>
        }
        @if (!isAddressChangeDisabled) {
          <div class="location-information__card--body-height">
            <ng-container *ngTemplateOutlet="tmplTitleAddressCardBody"></ng-container>
          </div>
        }
      </div>
      <div class="location-information__card"
        [ngClass]="{ 'location-information__card-min-height': !isAddressChangeDisabled }"
        [class.editHeight]="phoneEditMode" [class.priamryErrorHeight]="
          phoneNumberFormSubmitted && numberFormValidator.primaryNumber.errors && !numberFormValidator.altNumber.errors
        " [class.altErrorHeight]="
          phoneNumberFormSubmitted &&
          numberFormValidator.primaryNumber.errors &&
          !numberFormValidator.primaryNumber.errors
        " [class.errorHeight]="
          phoneNumberFormSubmitted && numberFormValidator.primaryNumber.errors && numberFormValidator.altNumber.errors
        ">
        <h3 data-test-id="dealer-contact-phone-numbers-header" class="location-information__card--title bold-title">
          {{dealerContactTranslations.phoneNumbers}}
        </h3>
        @if (!phoneEditMode) {
          <div class="location-information__card--info">
            <p data-test-id="dealer-contact-primary-phone-text" #primaryPhoneText class="card__info--bs-primary focus-outline-none" x-ms-format-detection="none"
              tabindex="-1" id="primaryPhone_text">
              {{dealerContactTranslations.primaryPhone}}: {{ primaryPhone }}
            </p>
            <p data-test-id="dealer-contact-alt-phone-text" class="card__info--alternative" x-ms-format-detection="none">{{dealerContactTranslations.textAltPhone}}
            {{ altPhone }}</p>
          </div>
          <div class="location-information__card--request">
            <button data-test-id="dealer-contact-edit-phone-btn" #editContactNumbers data-track-elem="button" data-track-name="Edit" class="btn btn-link p-0"
              id="edit-contact-numbers" (click)="onPhoneEditMode()"
              [attr.aria-label]="dealerContactTranslations.ariaLabelEditContact">
              {{dealerContactTranslations.edit}}
            </button>
          </div>
        }

        @if (phoneEditMode) {
          <form data-test-id="dealer-contact-phone-form" name="editPhoneNumber" class="form" [formGroup]="phoneNumberForm">
            <div class="form-group">
              <label for="primaryPhone" id="primaryPhone-label"> {{dealerContactTranslations.labelPrimaryPhone}}</label>
              <input data-test-id="dealer-contact-primary-phone-input" #contactPrimaryPhone type="text" class="form-control" id="primaryPhone" mask="000-000-0000"
                [value]="primaryPhone" formControlName="primaryNumber"
                [ngClass]="{ 'is-invalid': numberFormValidator.primaryNumber.errors }" required aria-required="true"
                aria-labelledby="primaryPhone-label primaryPhone-error" />
              @if (numberFormValidator.primaryNumber.errors) {
                <div aria-live="assertive" class="invalid-feedback"
                  id="primaryPhone-error">
                  {{dealerContactTranslations.enterPhoneNumber}}
                </div>
              }
              <label for="altPhone" id="altPhone-label"> {{dealerContactTranslations.alternatePhone}}</label>
              <input data-test-id="dealer-contact-alt-phone-input" type="text" class="form-control" id="altPhone" mask="000-000-0000" [value]="altPhone"
                formControlName="altNumber" [ngClass]="{ 'is-invalid': numberFormValidator.altNumber.errors }"
                aria-required="true" aria-labelledby="altPhone-label altPhone-error" />
              @if (numberFormValidator.altNumber.errors) {
                <div aria-live="assertive" class="invalid-feedback"
                  id="altPhone-error">
                  {{dealerContactTranslations.enterPhoneNumber}}
                </div>
              }
            </div>
          </form>
          <div class="location-information__card--action">
            <button data-test-id="dealer-contact-phone-save-btn" data-track-elem="button" data-track-name="Save" class="btn btn-primary bid-buttons me-2 saveButton"
              (click)="changePhoneNumbers()">
              {{dealerContactTranslations.btnSave}}
            </button>
            <button data-test-id="dealer-contact-phone-cancel-btn" data-track-elem="button" data-track-name="Cancel" class="btn btn-secondary cancel-btn bid-buttons"
              (click)="openMicroModal(modalId)">
              {{dealerContactTranslations.btnCancel}}
            </button>
          </div>
        }
      </div>
    </div>
    @if (!isMobile) {
      <ng-container *ngTemplateOutlet="tmplAddressChangeDrawer"></ng-container>
    }
  </div>

  <div class="contacts" data-test-id="dealer-contact-contacts-section">
    <h2 data-test-id="dealer-contact-contacts-header" id="contacts-title" class="contacts__title bold-title" tabindex="-1">
      {{dealerContactTranslations.labelContacts}}
    </h2>
    <p data-test-id="dealer-contact-contacts-info" class="contacts__info" aria-labelledby="contacts-title">
      {{dealerContactTranslations.contactInfo}}
    </p>
    @if (showContactDetailsError) {
      <error-message data-test-id="dealer-contact-details-error-message"></error-message>
    }
    @if (showContactDetailsSuccess) {
      <success-message data-test-id="dealer-contact-details-success-message" [message]="dealerContactTranslations.contactDetailsSuccessfullyUpdate"
      ></success-message>
    }
    <div class="contacts-table">
      <app-legacy-table data-test-id="dealer-contact-contacts-table" [columns]="columns" [data]="data" [tenantName]="tenantName$ | async" [cardConfig]="cardConfig"
        caption="{{dealerContactTranslations.captionDealerShip}}">
        <!-- Buyer Contact -->
        @if (showBuyerContacts) {
          <table-row-group>
            <table-row [columns]="columns" [row]="data?.buyer">
              <table-cell *appTableCell="let row; column: 'role'" id="buyer_contact_cell"> {{dealerContactTranslations.textBuyerContact}} </table-cell>
              <table-cell *appTableCell="let row; column: 'name'"> {{ row?.name }}</table-cell>
              <table-cell *appTableCell="let row; column: 'email'"> {{ row?.email }}</table-cell>
              <table-cell *appTableCell="let row; column: 'phone'">
                {{ row?.phone ? reformatPhone(row.phone) : '' }}
              </table-cell>
              <table-cell *appTableCell="let row; column: 'options'">
                <button #editBuyer
                  data-test-id="dealer-contact-edit-buyer-btn"
                  data-track-elem="button"
                  data-track-name="Edit"
                  class="btn btn-link p-0"
                  (click)="buyerDrawer.open(); updateForm('buyer', row)"
                  [attr.aria-label]="dealerContactTranslations.editBuyerContact"
                  id="edit-buyer"
                  >
                  {{dealerContactTranslations.edit}}
                </button>
                <app-save-changes-modal
                  data-test-id="dealer-contact-buyer-save-changes-modal"
                  (cancelEditing)="cancelContactEditing('buyer')"
                  (continueEditing)="continueContactEditing()"
                  modalId="buyer__save-changes-modal"
                  data-track-region="Save Buyer Changes"
                  >
                </app-save-changes-modal>
              </table-cell>
            </table-row>
            <table-row [row]="data?.buyer" [expandable]="true" #buyerDrawer="table-row">
              <table-cell *appTableCell="let row; colSpan: columns.length">
                <div class="container drawer">
                  <h3 data-test-id="dealer-contact-buyer-drawer-header" tabindex="-1" class="focus-outline-none" id="buyer_header">{{dealerContactTranslations.editBuyerContact}}</h3>
                  @if (!isAlternateBuyerValid) {
                    <p class="alternate-contact-general-error">
                      <img class="icon-warning-filled-red"
                        src="assets/icons/icon-warning-filled/icon-warning-filled-red.svg" alt="Warning Icon">
                        {{dealerContactTranslations.alternateContactGeneralError}}
                      </p>
                    }
                    <p>
                      {{dealerContactTranslations.editBuyerContactInfo}}
                    </p>
                    <form
                      data-test-id="dealer-contact-buyer-form"
                      name="form"
                      class="form"
                      [formGroup]="buyerContactForm"
                      (ngSubmit)="onSubmit($event, 'buyer', row)"
                      >
                    @if (showSameAsSellerCheckbox) {
                      <div class="form-group same-as-seller-wrapper">
                        <div class="custom-control custom-checkbox">
                          <input data-test-id="dealer-contact-buyer-same-as-seller-checkbox" id="same-as-seller-buyer-checkbox" type="checkbox" (change)="sameAsSeller($event, 'buyer')" class="custom-control-input" />
                          <label for="same-as-seller-buyer-checkbox" class="custom-control-label checkbox-label-space">{{dealerContactTranslations.labelSameAsSellerCheckbox}}</label>
                        </div>
                      </div>
                    }
                    <fieldset class="form-row" [disabled]="sameAsSellerFieldStyle.buyer">
                      <legend class="d-none">Buyer Primary Contact</legend>
                      <div class="form-group col-sm-12 col-md-4 col-lg-3">
                        <label for="buyer_name" id="buyer_name-label">{{dealerContactTranslations.name}}</label>
                        <input
                          data-test-id="dealer-contact-buyer-name-input"
                          id="buyer_name"
                          type="text"
                          class="form-control"
                          formControlName="name"
                          aria-required="true"
                          [ngClass]="{ 'is-invalid': buyerContactForm.controls?.name.errors }"
                          aria-labelledby="buyer_name-label buyer_name-error"
                          />
                        @if (buyerContactForm?.controls?.name.errors) {
                          <div
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="buyer_name-error"
                            >
                            {{dealerContactTranslations.enterName}}
                          </div>
                        }
                      </div>
                      <div class="form-group col-sm-12 col-md-4 col-lg-3 offset-lg-1">
                        <label for="buyer_email" id="buyer_email-label">{{dealerContactTranslations.email}}</label>
                        <input
                          data-test-id="dealer-contact-buyer-email-input"
                          id="buyer_email"
                          type="text"
                          class="form-control"
                          formControlName="email"
                          aria-required="true"
                          [ngClass]="{ 'is-invalid': buyerContactForm.controls?.email.errors }"
                          email
                          aria-required="true"
                          aria-labelledby="buyer_email-label buyer_email-error"
                          />
                        @if (buyerContactForm?.controls?.email.errors) {
                          <div
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="buyer_email-error"
                            >
                            {{dealerContactTranslations.enterEmail}}
                          </div>
                        }
                      </div>
                      <div class="form-group col-sm-12 col-md-4 col-lg-3 offset-lg-1">
                        <label for="buyer_phone" id="buyer_phone-label">{{dealerContactTranslations.phone}}</label>
                        <input
                          data-test-id="dealer-contact-buyer-phone-input"
                          id="buyer_phone"
                          type="text"
                          class="form-control"
                          formControlName="phone"
                          aria-required="true"
                          [ngClass]="{ 'is-invalid': buyerContactForm.controls?.phone.errors }"
                          mask="000-000-0000"
                          aria-required="true"
                          aria-labelledby="buyer_phone-label buyer_phone-error"
                          />
                        @if (buyerContactForm?.controls?.phone.errors) {
                          <div
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="buyer_phone-error"
                            >
                            {{dealerContactTranslations.enterPhoneToContinue}}
                          </div>
                        }
                      </div>
                    </fieldset>
                    @if (isCanadianTenantEnabled) {
                      <div class="control-wrapper form-group">
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" formControlName="language" class="custom-control-input excludes__input checkbox-left-space" id="buyer_language"
                            />
                          <label id="buyer-language-label" class="custom-control-label excludes__label checkbox-label-space checkbox-label-space" for="buyer_language">
                          {{dealerContactTranslations.frenchPreferred}}</label>
                        </div>
                      </div>
                    }
                    <h3 data-test-id="dealer-contact-buyer-alternate-header" tabindex="-1" class="focus-outline-none" id="buyer_alternate_header">{{dealerContactTranslations.alternateBuyerContact}}</h3>
                    <div class="form-row" formGroupName="alternateBuyer">
                      <div class="form-group col-sm-12 col-md-4 col-lg-3">
                        <label for="buyer_alternate_name" id="buyer_alternate_name-label">{{dealerContactTranslations.name}}</label>
                        <input
                          data-test-id="dealer-contact-buyer-alt-name-input"
                          id="buyer_alternate_name"
                          type="text"
                          class="form-control"
                          formControlName="name"
                          aria-required="true"
                          [ngClass]="{ 'is-invalid': !isAlternateBuyerNameValid }"
                          aria-labelledby="buyer_alternate_name-label buyer_alternate_name-error"
                          />
                        @if (!isAlternateBuyerNameValid) {
                          <div
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="buyer_alternate_name-error"
                            >
                            {{dealerContactTranslations.enterName}}
                          </div>
                        }
                      </div>
                      <div class="form-group col-sm-12 col-md-4 col-lg-3 offset-lg-1">
                        <label for="buyer_alternate_email" id="buyer_alternate_email-label">{{dealerContactTranslations.email}}</label>
                        <input
                          data-test-id="dealer-contact-buyer-alt-email-input"
                          id="buyer_alternate_email"
                          type="text"
                          class="form-control"
                          formControlName="email"
                          [ngClass]="{ 'is-invalid': !isAlternateBuyerEmailValid }"
                          email
                          aria-required="true"
                          aria-labelledby="buyer_alternate_email-label buyer_alternate_email-error"
                          />
                        @if (!isAlternateBuyerEmailValid) {
                          <div
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="buyer_alternate_email-error"
                            >
                            {{dealerContactTranslations.enterEmail}}
                          </div>
                        }
                      </div>
                      <div class="form-group col-sm-12 col-md-4 col-lg-3 offset-lg-1">
                        <label for="buyer_alternate_phone" id="buyer_alternate_phone-label">{{dealerContactTranslations.phone}}</label>
                        <input
                          data-test-id="dealer-contact-buyer-alt-phone-input"
                          id="buyer_alternate_phone"
                          type="text"
                          class="form-control"
                          formControlName="phone"
                          [ngClass]="{ 'is-invalid': !isAlternateBuyerPhoneValid }"
                          mask="000-000-0000"
                          aria-required="true"
                          aria-labelledby="buyer_alternate_phone-label buyer_alternate_phone-error"
                          />
                        @if (!isAlternateBuyerPhoneValid) {
                          <div
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="buyer_alternate_phone-error"
                            >
                            {{dealerContactTranslations.enterPhoneToContinue}}
                          </div>
                        }
                      </div>
                      @if (isCanadianTenantEnabled) {
                        <div class="control-wrapper form-group alt-checkbox-space">
                          <div class="custom-control custom-checkbox checkbox-margin-space">
                            <input type="checkbox" formControlName="language" class="custom-control-input excludes__input" id="buyer_alternate_language"
                              />
                            <label id="buyer-alternate-language-label" class="custom-control-label excludes__label checkbox-label-space" for="buyer_alternate_language">
                            {{dealerContactTranslations.frenchPreferred}}</label>
                          </div>
                        </div>
                      }
                    </div>
                    <div class="d-flex flex-column flex-md-row md-justify-content-start">
                      <button data-test-id="dealer-contact-buyer-save-btn" data-track-elem="button" data-track-name="Save" type="submit" class="btn btn-primary">
                        {{dealerContactTranslations.btnSave}}
                      </button>
                      <button
                        data-test-id="dealer-contact-buyer-cancel-btn"
                        data-track-elem="button"
                        data-track-name="Cancel"
                        class="ms-md-2 mt-3 mt-md-0 btn btn-secondary bid-buttons"
                        (click)="cancelContactForm($event, 'buyer')"
                        >
                        {{dealerContactTranslations.btnCancel}}
                      </button>
                    </div>
                  </form>
                  <button
                    data-test-id="dealer-contact-buyer-drawer-close-btn"
                    data-track-elem="icon"
                    data-track-name="Close"
                    data-track-trigger="close"
                    class="drawer__close"
                    [attr.aria-label]="dealerContactTranslations.btnClose"
                    (click)="cancelContactForm($event, 'buyer')"
                    >
                    <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
                  </button>
                </div>
              </table-cell>
            </table-row>
          </table-row-group>
        }
        <!-- Seller Contact -->
        @if (showSellerContacts) {
          <table-row-group>
            <table-row [columns]="columns" [row]="data?.seller">
              <table-cell *appTableCell="let row; column: 'role'" id="seller_contact_cell"> {{dealerContactTranslations.sellerContact}}</table-cell>
              <table-cell *appTableCell="let row; column: 'name'"> {{ row?.name }}</table-cell>
              <table-cell *appTableCell="let row; column: 'email'"> {{ row?.email }}</table-cell>
              <table-cell *appTableCell="let row; column: 'phone'">
                {{ row?.phone ? reformatPhone(row.phone) : '' }}
              </table-cell>
              <table-cell *appTableCell="let row; column: 'options'">
                <button #editSeller
                  data-test-id="dealer-contact-edit-seller-btn"
                  data-track-elem="button"
                  data-track-name="Edit"
                  class="btn btn-link p-0"
                  (click)="sellerDrawer.open(); updateForm('seller', row)"
                  [attr.aria-label]="dealerContactTranslations.editSellerContact"
                  id="edit-seller"
                  >
                  {{dealerContactTranslations.edit}}
                </button>
                <app-save-changes-modal
                  data-test-id="dealer-contact-seller-save-changes-modal"
                  (cancelEditing)="cancelContactEditing('seller')"
                  (continueEditing)="continueContactEditing()"
                  modalId="seller__save-changes-modal"
                  data-track-region="Save Seller Changes"
                  >
                </app-save-changes-modal>
              </table-cell>
            </table-row>
            <table-row [row]="data?.seller" [expandable]="true" #sellerDrawer="table-row">
              <table-cell *appTableCell="let row; colSpan: columns.length">
                <div class="container drawer">
                  <h3 data-test-id="dealer-contact-seller-drawer-header" tabindex="-1" class="focus-outline-none" id="seller_header">{{dealerContactTranslations.editSellerContact}}</h3>
                  @if (!isAlternateSellerValid) {
                    <p class="alternate-contact-general-error">
                      <img class="icon-warning-filled-red"
                        src="assets/icons/icon-warning-filled/icon-warning-filled-red.svg" alt="Warning Icon">
                        {{dealerContactTranslations.alternateContactGeneralError}}
                      </p>
                    }
                    <p>
                      {{dealerContactTranslations.sellerContactInfo}}
                    </p>
                    <form
                      data-test-id="dealer-contact-seller-form"
                      name="form"
                      class="form"
                      [formGroup]="sellerContactForm"
                      (ngSubmit)="onSubmit($event, 'seller', row)"
                      >
                    <div class="form-row">
                      <div class="form-group col-sm-12 col-md-4 col-lg-3">
                        <label for="seller_name" id="seller_name-label">{{dealerContactTranslations.name}}</label>
                        <input
                          data-test-id="dealer-contact-seller-name-input"
                          id="seller_name"
                          type="text"
                          class="form-control"
                          formControlName="name"
                          aria-required="true"
                          [ngClass]="{ 'is-invalid': sellerContactForm.controls?.name.errors }"
                          aria-labelledby="seller_name-label seller_name"
                          />
                        @if (sellerContactForm?.controls?.name.errors) {
                          <div
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="seller_name-error"
                            >
                            {{dealerContactTranslations.enterName}}
                          </div>
                        }
                      </div>
                      <div class="form-group col-sm-12 col-md-4 col-lg-3 offset-lg-1">
                        <label for="seller_email" id="seller_email-label">{{dealerContactTranslations.email}}</label>
                        <input
                          data-test-id="dealer-contact-seller-email-input"
                          id="seller_email"
                          type="text"
                          class="form-control"
                          formControlName="email"
                          aria-required="true"
                          [ngClass]="{ 'is-invalid': sellerContactForm.controls?.email.errors }"
                          email
                          aria-required="true"
                          aria-labelledby="seller_email-label seller_email-error"
                          />
                        @if (sellerContactForm?.controls?.email.errors) {
                          <div
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="seller_email-error"
                            >
                            {{dealerContactTranslations.enterEmail}}
                          </div>
                        }
                      </div>
                      <div class="form-group col-sm-12 col-md-4 col-lg-3 offset-lg-1">
                        <label for="seller_phone" id="seller_phone-label">{{dealerContactTranslations.phone}}</label>
                        <input
                          data-test-id="dealer-contact-seller-phone-input"
                          id="seller_phone"
                          type="text"
                          class="form-control"
                          formControlName="phone"
                          [ngClass]="{ 'is-invalid': sellerContactForm.controls?.phone.errors }"
                          mask="000-000-0000"
                          aria-required="true"
                          aria-labelledby="seller_phone-label seller_phone-error"
                          />
                        @if (sellerContactForm?.controls?.phone.errors) {
                          <div
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="seller_phone-error"
                            >
                            {{dealerContactTranslations.enterPhoneToContinue}}
                          </div>
                        }
                      </div>
                    </div>
                    @if (isCanadianTenantEnabled) {
                      <div class="control-wrapper form-group">
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" formControlName="language" class="custom-control-input excludes__input" id="seller_language"
                            />
                          <label id="seller-language-label" class="custom-control-label excludes__label checkbox-label-space" for="seller_language">
                          {{dealerContactTranslations.frenchPreferred}}</label>
                        </div>
                      </div>
                    }
                    <h3 data-test-id="dealer-contact-seller-alternate-header" tabindex="-1" class="focus-outline-none" id="seller_alternate_header">{{dealerContactTranslations.alternateSellerContact}}</h3>
                    <div class="form-row" formGroupName="alternateSeller">
                      <div class="form-group col-sm-12 col-md-4 col-lg-3">
                        <label for="seller_alternate_name" id="seller_alternate_name-label">{{dealerContactTranslations.name}}</label>
                        <input
                          data-test-id="dealer-contact-seller-alt-name-input"
                          id="seller_alternate_name"
                          type="text"
                          class="form-control"
                          formControlName="name"
                          aria-required="true"
                          [ngClass]="{ 'is-invalid': !isAlternateSellerNameValid }"
                          aria-labelledby="seller_alternate_name-label seller_alternate_name-error"
                          />
                        @if (!isAlternateSellerNameValid) {
                          <div
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="seller_alternate_name-error"
                            >
                            {{dealerContactTranslations.enterName}}
                          </div>
                        }
                      </div>
                      <div class="form-group col-sm-12 col-md-4 col-lg-3 offset-lg-1">
                        <label for="seller_alternate_email" id="seller_alternate_email-label">{{dealerContactTranslations.email}}</label>
                        <input
                          data-test-id="dealer-contact-seller-alt-email-input"
                          id="seller_alternate_email"
                          type="text"
                          class="form-control"
                          formControlName="email"
                          [ngClass]="{ 'is-invalid': !isAlternateSellerEmailValid }"
                          email
                          aria-required="true"
                          aria-labelledby="seller_alternate_email-label seller_alternate_email-error"
                          />
                        @if (!isAlternateSellerEmailValid) {
                          <div
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="seller_alternate_email-error"
                            >
                            {{dealerContactTranslations.enterEmail}}
                          </div>
                        }
                      </div>
                      <div class="form-group col-sm-12 col-md-4 col-lg-3 offset-lg-1">
                        <label for="seller_alternate_phone" id="seller_alternate_phone-label">{{dealerContactTranslations.phone}}</label>
                        <input
                          data-test-id="dealer-contact-seller-alt-phone-input"
                          id="seller_alternate_phone"
                          type="text"
                          class="form-control"
                          formControlName="phone"
                          [ngClass]="{ 'is-invalid': !isAlternateSellerPhoneValid }"
                          mask="000-000-0000"
                          aria-required="true"
                          aria-labelledby="seller_alternate_phone-label seller_alternate_phone-error"
                          />
                        @if (!isAlternateSellerPhoneValid) {
                          <div
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="seller_alternate_phone-error"
                            >
                            {{dealerContactTranslations.enterPhoneToContinue}}
                          </div>
                        }
                      </div>
                      @if (isCanadianTenantEnabled) {
                        <div class="control-wrapper form-group alt-checkbox-space">
                          <div class="custom-control custom-checkbox checkbox-margin-space">
                            <input type="checkbox" formControlName="language" class="custom-control-input excludes__input" id="seller_alternate_language"
                              />
                            <label id="seller-alternate-language-label" class="custom-control-label excludes__label checkbox-label-space" for="seller_alternate_language">
                            {{dealerContactTranslations.frenchPreferred}}</label>
                          </div>
                        </div>
                      }
                    </div>
                    <div class="d-flex flex-column flex-md-row md-justify-content-start">
                      <button data-test-id="dealer-contact-seller-save-btn" data-track-elem="button" data-track-name="Save" type="submit" class="btn btn-primary">
                        {{dealerContactTranslations.btnSave}}
                      </button>
                      <button
                        data-test-id="dealer-contact-seller-cancel-btn"
                        data-track-elem="button"
                        data-track-name="Cancel"
                        class="ms-md-2 mt-3 mt-md-0 btn btn-secondary bid-buttons"
                        (click)="cancelContactForm($event, 'seller')"
                        >
                        {{dealerContactTranslations.btnCancel}}
                      </button>
                    </div>
                  </form>
                  <button
                    data-test-id="dealer-contact-seller-drawer-close-btn"
                    data-track-elem="icon"
                    data-track-name="Close"
                    data-track-trigger="close"
                    class="drawer__close"
                    [attr.aria-label]="dealerContactTranslations.btnClose"
                    (click)="cancelContactForm($event, 'seller')"
                    >
                    <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
                  </button>
                </div>
              </table-cell>
            </table-row>
          </table-row-group>
        }
        <!-- Pickup Contact -->
        @if (showSellerContacts) {
          <table-row-group>
            <table-row [columns]="columns" [row]="data?.pickup">
              <table-cell *appTableCell="let row; column: 'role'" id="pickup_contact_cell"> {{dealerContactTranslations.pickupContact}} </table-cell>
              <table-cell *appTableCell="let row; column: 'name'"> {{ row?.name }}</table-cell>
              <table-cell *appTableCell="let row; column: 'email'"> {{ row?.email }}</table-cell>
              <table-cell *appTableCell="let row; column: 'phone'">
                {{ row?.phone ? reformatPhone(row.phone) : '' }}
              </table-cell>
              <table-cell *appTableCell="let row; column: 'options'">
                <button #editPickup
                  data-test-id="dealer-contact-edit-pickup-btn"
                  data-track-elem="button"
                  data-track-name="Edit"
                  class="btn btn-link p-0"
                  (click)="pickupDrawer.open(); updateForm('pickup', row)"
                  [attr.aria-label]="dealerContactTranslations.editPickupContact"
                  id="edit-pickup"
                  >
                  {{dealerContactTranslations.edit}}
                </button>
                <app-save-changes-modal
                  data-test-id="dealer-contact-pickup-save-changes-modal"
                  (cancelEditing)="cancelContactEditing('pickup')"
                  (continueEditing)="continueContactEditing()"
                  modalId="pickup__save-changes-modal"
                  data-track-region="Pickup Save Changes"
                  >
                </app-save-changes-modal>
              </table-cell>
            </table-row>
            <table-row [row]="data?.pickup" [expandable]="true" #pickupDrawer="table-row">
              <table-cell *appTableCell="let row; colSpan: columns.length">
                <div class="container drawer">
                  <h3 data-test-id="dealer-contact-pickup-drawer-header" tabindex="-1" class="focus-outline-none" id="pickup_header">{{dealerContactTranslations.editPickupContact}}</h3>
                  @if (!isAlternatePickupValid) {
                      <p class="alternate-contact-general-error">
                      <img class="icon-warning-filled-red"
                        src="assets/icons/icon-warning-filled/icon-warning-filled-red.svg" alt="Warning Icon">
                        {{dealerContactTranslations.alternateContactGeneralError}}
                      </p>
                    }
                    <p>
                      {{dealerContactTranslations.editPickupContactMessage}}
                    </p>
                    <form
                      data-test-id="dealer-contact-pickup-form"
                      name="form"
                      class="form"
                      [formGroup]="pickupContactForm"
                      (ngSubmit)="onSubmit($event, 'pickup', row)"
                      >
                    @if (showSameAsSellerCheckbox) {
                      <div class="form-group same-as-seller-wrapper">
                        <div class="custom-control custom-checkbox">
                          <input data-test-id="dealer-contact-pickup-same-as-seller-checkbox" id="same-as-seller-pickup-checkbox" type="checkbox" (change)="sameAsSeller($event, 'pickup')" class="custom-control-input" />
                          <label for="same-as-seller-pickup-checkbox" class="custom-control-label checkbox-label-space">{{dealerContactTranslations.labelSameAsSellerCheckbox}}</label>
                        </div>
                      </div>
                    }
                    <fieldset class="form-row" [disabled]="sameAsSellerFieldStyle.pickup">
                      <legend class="d-none">Pickup Primary Contact</legend>
                      <div class="form-group col-sm-12 col-md-4 col-lg-3">
                        <label for="pickup_name" id="pickup_name-label">{{dealerContactTranslations.name}}</label>
                        <input
                          data-test-id="dealer-contact-pickup-name-input"
                          id="pickup_name"
                          type="text"
                          class="form-control"
                          formControlName="name"
                          aria-required="true"
                          [ngClass]="{ 'is-invalid': pickupContactForm.controls?.name.errors }"
                          aria-labelledby="pickup_name-label pickup_name-error"
                          />
                        @if (pickupContactForm?.controls?.name.errors) {
                          <div
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="pickup_name-error"
                            >
                            {{dealerContactTranslations.enterName}}
                          </div>
                        }
                      </div>
                      <div class="form-group col-sm-12 col-md-4 col-lg-3 offset-lg-1">
                        <label for="pickup_email" id="pickup_email-label">{{dealerContactTranslations.email}}</label>
                        <input
                          data-test-id="dealer-contact-pickup-email-input"
                          id="pickup_email"
                          aria-labelledby="pickup_email-label pickup_email-error"
                          type="text"
                          class="form-control"
                          formControlName="email"
                          aria-required="true"
                          [ngClass]="{ 'is-invalid': pickupContactForm.controls?.email.errors }"
                          email
                          aria-required="true"
                          />
                        @if (pickupContactForm?.controls?.email.errors) {
                          <div
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="pickup_email-error"
                            >
                            {{dealerContactTranslations.enterEmail}}
                          </div>
                        }
                      </div>
                      <div class="form-group col-sm-12 col-md-4 col-lg-3 offset-lg-1">
                        <label for="pickup_phone" id="pickup_phone-label">{{dealerContactTranslations.phone}}</label>
                        <input
                          data-test-id="dealer-contact-pickup-phone-input"
                          id="pickup_phone"
                          aria-labelledby="pickup_phone-label pickup_phone-error"
                          type="text"
                          class="form-control"
                          formControlName="phone"
                          aria-required="true"
                          [ngClass]="{ 'is-invalid': pickupContactForm.controls?.phone.errors }"
                          mask="000-000-0000"
                          aria-required="true"
                          />
                        @if (pickupContactForm?.controls?.phone.errors) {
                          <div
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="pickup_phone-error"
                            >
                            {{dealerContactTranslations.enterPhoneToContinue}}
                          </div>
                        }
                      </div>
                    </fieldset>
                    @if (isCanadianTenantEnabled) {
                      <div class="control-wrapper form-group">
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" formControlName="language" class="custom-control-input excludes__input" id="pickup_language"
                            />
                          <label id="pickup-language-label" class="custom-control-label excludes__label checkbox-label-space" for="pickup_language">
                          {{dealerContactTranslations.frenchPreferred}}</label>
                        </div>
                      </div>
                    }
                    <h3 data-test-id="dealer-contact-pickup-alternate-header" tabindex="-1" class="focus-outline-none" id="pickup_alternate_header">{{dealerContactTranslations.alternatePickupContact}}</h3>
                    <div class="form-row" formGroupName="alternatePickup">
                      <div class="form-group col-sm-12 col-md-4 col-lg-3">
                        <label for="pickup_alternate_name" id="pickup_alternate_name-label">{{dealerContactTranslations.name}}</label>
                        <input
                          data-test-id="dealer-contact-pickup-alt-name-input"
                          id="pickup_alternate_name"
                          type="text"
                          class="form-control"
                          formControlName="name"
                          aria-required="true"
                          [ngClass]="{ 'is-invalid': !isAlternatePickupNameValid}"
                          aria-labelledby="pickup_alternate_name-label pickup_alternate_name-error"
                          />
                        @if (!isAlternatePickupNameValid) {
                          <div
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="pickup_alternate_name-error"
                            >
                            {{dealerContactTranslations.enterName}}
                          </div>
                        }
                      </div>
                      <div class="form-group col-sm-12 col-md-4 col-lg-3 offset-lg-1">
                        <label for="pickup_alternate_email" id="pickup_alternate_email-label">{{dealerContactTranslations.email}}</label>
                        <input
                          data-test-id="dealer-contact-pickup-alt-email-input"
                          id="pickup_alternate_email"
                          type="text"
                          class="form-control"
                          formControlName="email"
                          [ngClass]="{ 'is-invalid': !isAlternatePickupEmailValid }"
                          email
                          aria-required="true"
                          aria-labelledby="pickup_alternate_email-label pickup_alternate_email-error"
                          />
                        @if (!isAlternatePickupEmailValid) {
                          <div
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="pickup_alternate_email-error"
                            >
                            {{dealerContactTranslations.enterEmail}}
                          </div>
                        }
                      </div>
                      <div class="form-group col-sm-12 col-md-4 col-lg-3 offset-lg-1">
                        <label for="pickup_alternate_phone" id="pickup_alternate_phone-label">{{dealerContactTranslations.phone}}</label>
                        <input
                          data-test-id="dealer-contact-pickup-alt-phone-input"
                          id="pickup_alternate_phone"
                          type="text"
                          class="form-control"
                          formControlName="phone"
                          [ngClass]="{ 'is-invalid': !isAlternatePickupPhoneValid }"
                          mask="000-000-0000"
                          aria-required="true"
                          aria-labelledby="pickup_alternate_phone-label pickup_alternate_phone-error"
                          />
                        @if (!isAlternatePickupPhoneValid) {
                          <div
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="pickup_alternate_phone-error"
                            >
                            {{dealerContactTranslations.enterPhoneToContinue}}
                          </div>
                        }
                      </div>
                      @if (isCanadianTenantEnabled) {
                        <div class="control-wrapper form-group alt-checkbox-space">
                          <div class="custom-control custom-checkbox checkbox-margin-space">
                            <input type="checkbox" formControlName="language" class="custom-control-input excludes__input" id="pickup_alternate_language"
                              />
                            <label id="pickup-alternate-language-label" class="custom-control-label excludes__label checkbox-label-space" for="pickup_alternate_language">
                            {{dealerContactTranslations.frenchPreferred}}</label>
                          </div>
                        </div>
                      }
                    </div>
                    <div class="d-flex flex-column flex-md-row md-justify-content-start">
                      <button data-test-id="dealer-contact-pickup-save-btn" data-track-elem="button" data-track-name="Save" type="submit" class="btn btn-primary">
                        {{dealerContactTranslations.btnSave}}
                      </button>
                      <button
                        data-test-id="dealer-contact-pickup-cancel-btn"
                        data-track-elem="button"
                        data-track-name="Cancel"
                        class="ms-md-2 mt-3 mt-md-0 btn btn-secondary bid-buttons"
                        (click)="cancelContactForm($event, 'pickup')"
                        >
                        {{dealerContactTranslations.btnCancel}}
                      </button>
                    </div>
                  </form>
                  <button
                    data-test-id="dealer-contact-pickup-drawer-close-btn"
                    data-track-elem="icon"
                    data-track-name="Close"
                    data-track-trigger="close"
                    class="drawer__close"
                    [attr.aria-label]="dealerContactTranslations.btnClose"
                    (click)="cancelContactForm($event, 'pickup')"
                    >
                    <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
                  </button>
                </div>
              </table-cell>
            </table-row>
          </table-row-group>
        }
        <!-- Title Contact -->
        <table-row-group>
          <table-row [columns]="columns" [row]="data?.title">
            <table-cell *appTableCell="let row; column: 'role'"
            id="title_contact_cell">{{dealerContactTranslations.titleContact}}</table-cell>
            <table-cell *appTableCell="let row; column: 'name'"> {{ row?.name }}</table-cell>
            <table-cell *appTableCell="let row; column: 'email'"> {{ row?.email }}</table-cell>
            <table-cell *appTableCell="let row; column: 'phone'">
              {{ row?.phone ? reformatPhone(row.phone) : '' }}
            </table-cell>
            <table-cell *appTableCell="let row; column: 'options'">
              <button #editTitle data-test-id="dealer-contact-edit-title-btn" data-track-elem="button" data-track-name="Edit" class="btn btn-link p-0"
                (click)="titleDrawer.open(); updateForm('title', row)"
                [attr.aria-label]="dealerContactTranslations.editTitleContact" id="edit-title">
                {{dealerContactTranslations.edit}}
              </button>
              <app-save-changes-modal data-test-id="dealer-contact-title-save-changes-modal" (cancelEditing)="cancelContactEditing('title')"
                (continueEditing)="continueContactEditing()" modalId="title__save-changes-modal"
                data-track-region="Title Save Changes">
              </app-save-changes-modal>
            </table-cell>
          </table-row>
          <table-row [row]="data?.title" [expandable]="true" #titleDrawer="table-row">
            <table-cell *appTableCell="let row; colSpan: columns.length">
              <div class="container drawer">
                <h3 data-test-id="dealer-contact-title-drawer-header" tabindex="-1" class="focus-outline-none" id="title_header">
                {{dealerContactTranslations.editTitleContact}}</h3>
                <p>
                  {{dealerContactTranslations.editTitleContactMessage}}
                </p>
                <form
                  data-test-id="dealer-contact-title-form"
                  name="form"
                  class="form"
                  [formGroup]="titleContactForm"
                  (ngSubmit)="onSubmit($event, 'title', row)"
                  >
                  @if (showSameAsSellerCheckbox) {
                    <div class="form-group same-as-seller-wrapper">
                      <div class="custom-control custom-checkbox">
                        <input data-test-id="dealer-contact-title-same-as-seller-checkbox" id="same-as-seller-title-checkbox" type="checkbox" (change)="sameAsSeller($event, 'title')" class="custom-control-input" />
                        <label for="same-as-seller-title-checkbox" class="custom-control-label checkbox-label-space">{{dealerContactTranslations.labelSameAsSellerCheckbox}}</label>
                      </div>
                    </div>
                  }
                  <fieldset class="form-row" [disabled]="sameAsSellerFieldStyle.title">
                    <legend class="d-none">Title Primary Contact</legend>
                    <div class="form-group col-sm-12 col-md-4 col-lg-3">
                      <label for="title_name" id="title_name-label">{{dealerContactTranslations.name}}</label>
                      <input data-test-id="dealer-contact-title-name-input" id="title_name" type="text" class="form-control" formControlName="name"
                        aria-required="true" [ngClass]="{ 'is-invalid': titleContactForm.controls?.name.errors }"
                        aria-labelledby="title_name-label title_name-error" />
                      @if (titleContactForm?.controls?.name.errors) {
                        <div aria-live="assertive"
                          class="invalid-feedback" id="title_name-error">
                          {{dealerContactTranslations.enterName}}
                        </div>
                      }
                    </div>
                    <div class="form-group col-sm-12 col-md-4 col-lg-3 offset-lg-1">
                      <label for="title_email" id="title_email-label">{{dealerContactTranslations.email}}</label>
                      <input data-test-id="dealer-contact-title-email-input" id="title_email" aria-labelledby="title_email-label title_email-error" type="text"
                        class="form-control" formControlName="email" aria-required="true"
                        [ngClass]="{ 'is-invalid': titleContactForm.controls?.email.errors }" email
                        aria-required="true" />
                      @if (titleContactForm?.controls?.email.errors) {
                        <div aria-live="assertive"
                          class="invalid-feedback" id="title_email-error">
                          {{dealerContactTranslations.enterEmail}}
                        </div>
                      }
                    </div>
                    <div class="form-group col-sm-12 col-md-4 col-lg-3 offset-lg-1">
                      <label for="title_phone" id="title_phone-label">{{dealerContactTranslations.phone}}</label>
                      <input data-test-id="dealer-contact-title-phone-input" id="title_phone" aria-labelledby="title_phone-label title_phone-error" type="text"
                        class="form-control" formControlName="phone" aria-required="true"
                        [ngClass]="{ 'is-invalid': titleContactForm.controls?.phone.errors }" mask="000-000-0000"
                        aria-required="true" />
                      @if (titleContactForm?.controls?.phone.errors) {
                        <div aria-live="assertive"
                          class="invalid-feedback" id="title_phone-error">
                          {{dealerContactTranslations.enterPhoneToContinue}}
                        </div>
                      }
                    </div>
                  </fieldset>
                  @if (isCanadianTenantEnabled) {
                    <div class="control-wrapper form-group bottom-checkbox-space">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" formControlName="language" class="custom-control-input excludes__input" id="title_language"
                          />
                        <label id="title-language-label" class="custom-control-label excludes__label checkbox-label-space" for="title_language">
                        {{dealerContactTranslations.frenchPreferred}}</label>
                      </div>
                    </div>
                  }
                  <div class="d-flex flex-column flex-md-row md-justify-content-start">
                    <button data-test-id="dealer-contact-title-save-btn" data-track-elem="button" data-track-name="Save" type="submit" class="btn btn-primary">
                      {{dealerContactTranslations.btnSave}}
                    </button>
                    <button data-test-id="dealer-contact-title-cancel-btn" data-track-elem="button" data-track-name="Cancel"
                      class="ms-md-2 mt-3 mt-md-0 btn btn-secondary bid-buttons"
                      (click)="cancelContactForm($event, 'title')">
                      {{dealerContactTranslations.btnCancel}}
                    </button>
                  </div>
                </form>
                <button data-test-id="dealer-contact-title-drawer-close-btn" data-track-elem="icon" data-track-name="Close" data-track-trigger="close" class="drawer__close"
                  [attr.aria-label]="dealerContactTranslations.btnClose" (click)="cancelContactForm($event, 'title')">
                  <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
                </button>
              </div>
            </table-cell>
          </table-row>
        </table-row-group>

        <!-- Arbitration Contact -->
        <table-row-group>
          <table-row [columns]="columns" [row]="data?.arbitration">
            <table-cell *appTableCell="let row; column: 'role'"
            id="arbitration_contact_cell">{{dealerContactTranslations.arbitrationContact}}</table-cell>
            <table-cell *appTableCell="let row; column: 'name'"> {{ row?.name }}</table-cell>
            <table-cell *appTableCell="let row; column: 'email'"> {{ row?.email }}</table-cell>
            <table-cell *appTableCell="let row; column: 'phone'">
              {{ row?.phone ? reformatPhone(row.phone) : '' }}
            </table-cell>
            <table-cell *appTableCell="let row; column: 'options'">
              <button #editArbitration data-test-id="dealer-contact-edit-arbitration-btn" data-track-elem="button" data-track-name="Edit" class="btn btn-link p-0"
                (click)="arbitrationDrawer.open(); updateForm('arbitration', row)"
                [attr.aria-label]="dealerContactTranslations.editArbitrationContact" id="edit-arbitration">
                {{dealerContactTranslations.edit}}
              </button>
              <app-save-changes-modal data-test-id="dealer-contact-arbitration-save-changes-modal" (cancelEditing)="cancelContactEditing('arbitration')"
                (continueEditing)="continueContactEditing()" modalId="arbitration__save-changes-modal"
                data-track-region="Arbitration Save Changes">
              </app-save-changes-modal>
            </table-cell>
          </table-row>
          <table-row [row]="data?.arbitration" [expandable]="true" #arbitrationDrawer="table-row">
            <table-cell *appTableCell="let row; colSpan: columns.length">
              <div class="container drawer">
                <h3 data-test-id="dealer-contact-arbitration-drawer-header" tabindex="-1" class="focus-outline-none" id="arbitration_header">
                {{dealerContactTranslations.editArbitrationContact}}
                </h3>
                @if (shouldShowAlternateArbitrationError()) {
                  <p class="alternate-contact-general-error" aria-live="assertive" role="alert">
                  <img class="icon-warning-filled-red"
                      src="assets/icons/icon-warning-filled/icon-warning-filled-red.svg" alt="Warning Icon">
                  {{dealerContactTranslations.alternateContactGeneralError}}
                  </p>
                }
                <p>
                  {{dealerContactTranslations.editArbitrationContactMessage}}
                </p>
                <form
                  name="form"
                  class="form"
                  [formGroup]="arbitrationContactForm"
                  (ngSubmit)="onSubmit($event, 'arbitration', row)"
                  >
                  @if (showSameAsSellerCheckbox) {
                    <div class="form-group same-as-seller-wrapper">
                      <div class="custom-control custom-checkbox">
                        <input data-test-id="dealer-contact-arbitration-same-as-seller-checkbox" id="same-as-seller-arbitration-checkbox" type="checkbox" (change)="sameAsSeller($event, 'arbitration')" class="custom-control-input" />
                        <label for="same-as-seller-arbitration-checkbox" class="custom-control-label checkbox-label-space">{{dealerContactTranslations.labelSameAsSellerCheckbox}}</label>
                      </div>
                    </div>
                  }
                  <fieldset class="form-row" [disabled]="sameAsSellerFieldStyle.arbitration">
                    <legend class="d-none">Arbitration Primary Contact</legend>
                    <div class="form-group col-sm-12 col-md-4 col-lg-3">
                      <label for="arbitration_name"
                      id="arbitration_name-label">{{dealerContactTranslations.name}}</label>
                      <input id="arbitration_name" type="text" class="form-control" formControlName="name" data-test-id="app-dealer-contact-e-arbitration-name-input"
                        aria-required="true" [ngClass]="{ 'is-invalid': arbitrationContactForm.controls?.name.errors }"
                        aria-labelledby="arbitration_name-label arbitration_name-error" />
                      @if (arbitrationContactForm?.controls?.name.errors) {
                        <div aria-live="assertive"
                          class="invalid-feedback" id="arbitration_name-error" data-test-id="app-dealer-contact-e-arbitration-name-error">
                          {{dealerContactTranslations.enterName}}
                        </div>
                      }
                    </div>
                    <div class="form-group col-sm-12 col-md-4 col-lg-3 offset-lg-1">
                      <label for="arbitration_email"
                      id="arbitration_email-label">{{dealerContactTranslations.email}}</label>
                      <input id="arbitration_email" aria-labelledby="arbitration_email-label arbitration_email-error" data-test-id="app-dealer-contact-e-arbitration-email-input"
                        type="text" class="form-control" formControlName="email" aria-required="true"
                        [ngClass]="{ 'is-invalid': arbitrationContactForm.controls?.email.errors }" email
                        aria-required="true" />
                      @if (arbitrationContactForm?.controls?.email.errors) {
                        <div aria-live="assertive"
                          class="invalid-feedback" id="arbitration_email-error" data-test-id="app-dealer-contact-e-arbitration-email-error">
                          {{dealerContactTranslations.enterEmail}}
                        </div>
                      }
                    </div>
                    <div class="form-group col-sm-12 col-md-4 col-lg-3 offset-lg-1">
                      <label for="arbitration_phone"
                      id="arbitration_phone-label">{{dealerContactTranslations.phone}}</label>
                      <input id="arbitration_phone" aria-labelledby="arbitration_phone-label arbitration_phone-error" data-test-id="app-dealer-contact-e-arbitration-phone-input"
                        type="text" class="form-control" formControlName="phone" aria-required="true"
                        [ngClass]="{ 'is-invalid': arbitrationContactForm.controls?.phone.errors }" mask="000-000-0000"
                        aria-required="true" />
                      @if (arbitrationContactForm?.controls?.phone.errors) {
                        <div aria-live="assertive"
                          class="invalid-feedback" id="arbitration_phone-error" data-test-id="app-dealer-contact-e-arbitration-phone-error">
                          {{dealerContactTranslations.enterPhoneToContinue}}
                        </div>
                      }
                    </div>
                  </fieldset>
                  @if (isCanadianTenantEnabled) {
                    <div class="control-wrapper form-group bottom-checkbox-space">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" formControlName="language" class="custom-control-input excludes__input" id="arbitration_language" data-test-id="app-dealer-contact-e-arbitration-language-input" />
                        <label id="arbitration-language-label" class="custom-control-label excludes__label checkbox-label-space" for="arbitration_language">
                        {{dealerContactTranslations.frenchPreferred}}</label>
                      </div>
                    </div>
                  }
                  @if (isArbitrationSecondaryContactInfoEnabled) {
                    <h3 tabindex="-1" class="focus-outline-none" id="arbitration_alternate_header">{{dealerContactTranslations.alternateArbitrationContact}}</h3>
                    <div class="form-row" formGroupName="alternateArbitration">
                      <div class="form-group col-sm-12 col-md-4 col-lg-3">
                        <label for="arbitration_alternate_name" id="arbitration_alternate_name-label">{{dealerContactTranslations.name}}</label>
                        <input
                          id="arbitration_alternate_name"
                          type="text"
                          class="form-control"
                          formControlName="name"
                          aria-required="true"
                          [ngClass]="{ 'is-invalid': !isAlternateArbitrationNameValid || isArbitrationPrimaryAndSecondaryNameSame }"
                          aria-labelledby="arbitration_alternate_name-label arbitration_alternate_name-error"
                          data-test-id="app-dealer-contact-e-alternate-arbitration-name-input"
                          aria-invalid="true"
                          aria-describedby="arbitration_alternate_name-error"
                        />
                        @if (!isAlternateArbitrationNameValid) {
                          <div
                            role="alert"
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="arbitration_alternate_name-error"
                            data-test-id="app-dealer-contact-e-alternate-arbitration-name-error"
                          >
                            {{dealerContactTranslations.enterName}}
                          </div>
                        }
                        @if (isArbitrationPrimaryAndSecondaryNameSame) {
                          <div
                            role="alert"
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="arbitration_alternate_same_primary_secondary_name-error"
                            data-test-id="app-dealer-contact-e-alternate-arbitration-same_primary_secondary_name-error"
                          >
                            {{ dealerContactTranslations.samePrimarySecondaryNameError }}
                          </div>
                        }
                      </div>
                      <div class="form-group col-sm-12 col-md-4 col-lg-3 offset-lg-1">
                        <label for="arbitration_alternate_email" id="arbitration_alternate_email-label">{{dealerContactTranslations.email}}</label>
                        <input
                          id="arbitration_alternate_email"
                          type="text"
                          class="form-control"
                          formControlName="email"
                          [ngClass]="{ 'is-invalid': !isAlternateArbitrationEmailValid }"
                          email
                          aria-required="true"
                          aria-labelledby="arbitration_alternate_email-label arbitration_alternate_email-error"
                          aria-invalid="true"
                          aria-describedby="arbitration_alternate_email-error"
                          data-test-id="app-dealer-contact-e-alternate-arbitration-email-input"
                        />
                        @if(!isAlternateArbitrationEmailValid){
                          <div
                            role="alert"
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="arbitration_alternate_email-error"
                            data-test-id="app-dealer-contact-e-alternate-arbitration-email-error"
                          >
                            {{dealerContactTranslations.enterEmail}}
                          </div>
                        }
                      </div>
                      <div class="form-group col-sm-12 col-md-4 col-lg-3 offset-lg-1">
                        <label for="arbitration_alternate_phone" id="arbitration_alternate_phone-label">{{dealerContactTranslations.phone}}</label>
                        <input
                          id="arbitration_alternate_phone"
                          type="text"
                          class="form-control"
                          formControlName="phone"
                          [ngClass]="{ 'is-invalid': !isAlternateArbitrationPhoneValid }"
                          mask="000-000-0000"
                          aria-required="true"
                          aria-labelledby="arbitration_alternate_phone-label arbitration_alternate_phone-error"
                          aria-invalid="true"
                          aria-describedby="arbitration_alternate_phone-error"
                          data-test-id="app-dealer-contact-e-alternate-arbitration-phone-input"
                        />
                        @if(!isAlternateArbitrationPhoneValid){
                          <div
                            role="alert"
                            aria-live="assertive"
                            class="invalid-feedback"
                            id="arbitration_alternate_phone-error"
                            data-test-id="app-dealer-contact-e-alternate-arbitration-phone-error"
                          >
                            {{dealerContactTranslations.enterPhoneToContinue}}
                          </div>
                        }
                      </div>
                      @if (isCanadianTenantEnabled) {
                        <div class="control-wrapper form-group alt-checkbox-space">
                          <div class="custom-control custom-checkbox checkbox-margin-space">
                            <input type="checkbox" formControlName="language" class="custom-control-input excludes__input" id="arbitration_alternate_language" data-test-id="app-dealer-contact-e-alternate-arbitration-language-input"
                              />
                            <label id="arbitration-alternate-language-label" class="custom-control-label excludes__label checkbox-label-space" for="arbitration_alternate_language">
                              {{dealerContactTranslations.frenchPreferred}}</label>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  <div class="d-flex flex-column flex-md-row md-justify-content-start">
                    <button data-test-id="dealer-contact-arbitration-save-btn" data-track-elem="button" data-track-name="Save" type="submit" class="btn btn-primary">
                      {{dealerContactTranslations.btnSave}}
                    </button>
                    <button data-test-id="dealer-contact-arbitration-cancel-btn" data-track-elem="button" data-track-name="Cancel"
                      class="ms-md-2 mt-3 mt-md-0 btn btn-secondary bid-buttons"
                      (click)="cancelContactForm($event, 'arbitration')">
                      {{dealerContactTranslations.btnCancel}}
                    </button>
                  </div>
                </form>
                <button data-test-id="dealer-contact-arbitration-drawer-close-btn" data-track-elem="icon" data-track-name="Close" data-track-trigger="close" class="drawer__close"
                  [attr.aria-label]="dealerContactTranslations.btnClose"
                  (click)="cancelContactForm($event, 'arbitration')">
                  <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
                </button>
              </div>
            </table-cell>
          </table-row>
        </table-row-group>
      </app-legacy-table>
    </div>
  </div>
</div>

<ng-template #tmplPhysicalAddressCardBody>
  <h3 data-test-id="dealer-contact-physical-address-header" class="location-information__card--title bold-title">
    {{dealerContactTranslations.physicalAddress}}
  </h3>
  <div class="location-information__card--info">
    <p data-test-id="dealer-contact-physical-org-name" class="card__info--name">{{ organization?.oeName }}</p>
    <p data-test-id="dealer-contact-physical-address-line1" class="card__info--addressLine1">{{ organization?.physicalAddress.addressLine1 }}</p>
    @if (organization?.physicalAddress.addressLine2) {
      <p data-test-id="dealer-contact-physical-address-line2" class="card__info--addressLine2">
        {{ organization.physicalAddress.addressLine2 }}
      </p>
    }
    <p data-test-id="dealer-contact-physical-city-state-zip" class="card__info--cityStateZip">
      {{ organization?.physicalAddress.city
      }}@if (organization?.physicalAddress.city && organization?.physicalAddress.state) {
      ,&nbsp;
    }
    {{ organization?.physicalAddress.state
    }}@if (organization?.physicalAddress.zip) {
    &nbsp;
  }
  {{ organization?.physicalAddress.zip }}
</p>
</div>
<div class="location-information__card--request">
  <button data-test-id="dealer-contact-request-physical-change-btn" data-track-elem="button" data-track-name="Request Change" class="btn btn-link p-0"
    [ngClass]="{ 'd-none': isAddressChangeDisabled }" (click)="openAddressMicroModalOrDrawer('physical')"
    [attr.aria-label]="dealerContactTranslations.ariaLabelRequestPhysical">
    {{dealerContactTranslations.requestChange}}
  </button>
</div>
<ng-container *ngTemplateOutlet="tmplIndicatorPhysical"></ng-container>
</ng-template>

<ng-template #tmplTitleAddressCardBody>
  <h3 data-test-id="dealer-contact-title-address-header" class="location-information__card--title bold-title">
    {{dealerContactTranslations.titleAddress}}
  </h3>
  <div class="location-information__card--info">
    <p data-test-id="dealer-contact-title-org-name" class="card__info--name">{{ organization?.oeName }}</p>
    <p data-test-id="dealer-contact-title-address-line1" class="card__info--addressLine1">{{ organization?.mailingAddress.addressLine1 }}</p>
    @if (organization?.mailingAddress.addressLine2) {
      <p data-test-id="dealer-contact-title-address-line2" class="card__info--addressLine2">
        {{ organization?.mailingAddress.addressLine2 }}
      </p>
    }
    <p data-test-id="dealer-contact-title-city-state-zip" class="card__info--cityStateZip">
      {{ organization?.mailingAddress.city
      }}@if (organization?.mailingAddress.city && organization?.mailingAddress.state) {
      ,&nbsp;
      }{{ organization?.mailingAddress.state
      }}@if (organization?.mailingAddress.zip) {
      &nbsp;
    }
    {{ organization?.mailingAddress.zip }}
  </p>
</div>
<div class="location-information__card--request">
  <button data-test-id="dealer-contact-request-title-change-btn" data-track-elem="button" data-track-name="Request Change" class="btn btn-link p-0"
    [ngClass]="{ 'd-none': isAddressChangeDisabled }" (click)="openAddressMicroModalOrDrawer('title')"
    [attr.aria-label]="dealerContactTranslations.ariaLabelRequestTitle">
    {{dealerContactTranslations.requestChange}}
  </button>
</div>
<ng-container *ngTemplateOutlet="tmplIndicatorTitle"></ng-container>
</ng-template>

<ng-template #tmplAddressChangeDrawer>
  <app-address-change-drawer data-test-id="dealer-contact-address-change-drawer" [open]="isDrawerOpen" [variant]="variant" (success)="addressSaved()"
  (closed)="drawerClosed()" (sendError)="receiveError($event)"></app-address-change-drawer>
</ng-template>
<ng-template #tmplIndicatorPhysical>
  @if (requestPhysicalAddress) {
    <ng-container *ngTemplateOutlet="tmplDrawerIndicator"></ng-container>
  }
</ng-template>
<ng-template #tmplIndicatorTitle>
  @if (requestTitleAddress) {
    <ng-container *ngTemplateOutlet="tmplDrawerIndicator"></ng-container>
  }
</ng-template>
<ng-template #tmplDrawerIndicator>
  <div class="triangle">
    <div class="tg-border"></div>
    <div class="tg-overlay"></div>
  </div>
</ng-template>
<app-save-changes-modal data-test-id="dealer-contact-global-save-changes-modal" (continueEditing)="continueEditing($event)" (cancelEditing)="cancelEditing($event)"
  [modalId]="modalId" data-track-region="Dealer Contact Save Changes">
</app-save-changes-modal>

<app-address-change-modal data-test-id="dealer-contact-physical-address-change-modal" [variant]="'physical'" [modalId]="'physical-address-change-modal'" (success)="addressSaved()"
(sendError)="receiveError($event)"></app-address-change-modal>
<app-address-change-modal data-test-id="dealer-contact-title-address-change-modal" [variant]="'title'" [modalId]="'title-address-change-modal'" (success)="addressSaved()"
(sendError)="receiveError($event)"></app-address-change-modal>
<app-address-changed-modal data-test-id="dealer-contact-address-changed-modal" [modalId]="'address-changed-modal'"></app-address-changed-modal>
